import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import ReactDOM from 'react-dom';

//import components

class SingleFilterContent extends Component {
    constructor() {
        super();
        this.state = {
        };
    };

    componentDidMount() {
        this.setNode();
        this.updateWidth();
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    };

    setNode = () => {
        this.domNodeFilterContent = ReactDOM.findDOMNode(this.filterContent);
        window.addEventListener('resize', this.updateWidth);
    };

    updateWidth = () => {
        this.filterContentOffset = this.domNodeFilterContent.getBoundingClientRect();

        const isOutside = !this.state.isRight ?
                              Math.round(this.filterContentOffset.right) > window.innerWidth - 15
                              : Math.round(this.filterContentOffset.right + this.filterContentOffset.width - this.props.triggerWidth) > window.innerWidth - 15;

        this.setState({isRight: isOutside});
    };

    render() {
        const {clang, componentData, id, hideDefaultApply, applyFilter, isTouched, setOpenedFilter} = this.props;
        const {isRight} = this.state;

        return (
            <div className={`filter__content ${isRight ? 'isRight' : 'isLeft'}`} ref={el => this.filterContent = el}>
                <div className="filter__close-container">
                    <h5 className="filter__header">{lang[clang].filter_labels[id]}</h5>
                    <button className="filter__close" onClick={() => setOpenedFilter(null)}></button>
                </div>
                {componentData}
                {!hideDefaultApply &&
                    <div className={`filter__submit-container`}>
                        {isTouched &&
                            <button
                                onClick={() => applyFilter(id)}
                                className={`filter__submit active`}>
                                {lang[clang].results.submit}
                            </button>}
                        {!isTouched &&
                            <button
                                type="button"
                                onClick={() => setOpenedFilter(null)}
                                className={`filter__submit`}>
                                {lang[clang].results.close}
                            </button>}
                    </div>}
            </div>
        );
    };
};

SingleFilterContent.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SingleFilterContent);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/SingleFilterContent.js